<template>
    <component :is="containerTag" class="content-caddy" v-if="content" :class="className">
        <h1 v-if="content.showHeading" @click="toggleOpen">{{ content.name }}</h1>
        <content-component-loader :content="item" v-for="item in content.content" :key="item.hierarchyId">
            <slot></slot>
        </content-component-loader>
    </component>
</template>

<script lang="js">
    import ContentComponentLoader from './ContentComponentLoader.vue'

    export default {
        components: { ContentComponentLoader },
        props: {
            content: {
                type: Object,
                required: true
            },
            containerTag: {
                type: String,
                required: false,
                default: "section"
            }
        },
        data() {
            return {
                open: false
            }
        },
        computed: {
            className() {
                return this.content.name.replace(/&/g, '').replace(/\s\s/g, '-').replace(/\s/g, '-').toLowerCase() + (this.content.classNames ? ` ${this.content.classNames}` : "") + (this.open ? " open" : "");
            }
        },
        methods: {
            toggleOpen() {
                this.open = !this.open;
            }
        }
    };
</script>

<style>

    .site-footer .footer .content-caddy {
        text-align: left;
        margin: 0 auto 1.75rem auto;
        padding: 0 2rem;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        flex-basis: auto;
    }

    .site-footer .content-caddy h1 {
        font-family: var(--font-text);
        font-size: var(--font-size-4);
        margin-bottom: 0;
        text-align: left;
    }

    .site-footer .content-caddy p {
        font-size: 0.875em;
    }

        .site-footer .content-caddy p a {
            color: var(--white1);
            text-decoration: none;
        }

            .site-footer .content-caddy p a:hover {
                text-decoration: underline;
            }

    .site-footer .footer .content-caddy.social {
        justify-content: center;
    }

    .site-footer .footer .content-caddy.oa-link {
        margin-bottom: 0;
    }

    @media screen and (min-width: 800px) {
        .site-footer .content-caddy h1 {
            font-size: var(--font-size-6);
        }

        .site-footer .footer .content-caddy.oa-link {
            margin-bottom: 1.75rem;
        }
    }

</style>